import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useQueryClient } from 'react-query';
import { customAlert, notify } from '../../components/notify';
import { setProjAmtLimitServ } from '../../services/proj-service';
import LabelTxtFieldInfo from '../../components/LabelTxtFieldInfo';
import { useAuthContext } from '../../context/AuthContext';
import { isNotEmpty } from '../../utils/format';



function EditProjAmtLmit({ modalOpen, handleModalClose, handleMdlSaveClose, currProj }) {
    const { setLoadingScreen } = useAuthContext();
    const queryClient = useQueryClient();
    const theme = useTheme();

    async function handleSubmit(e) {
        setLoadingScreen(true)
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        try {
            const payload = {
                projIdStrg: currProj?.projIdStrg,
                amtLimit: isNotEmpty(inputObject?.amtLimit) ? inputObject?.amtLimit : null
            }
            const { message } = await setProjAmtLimitServ(payload);
            notify("success", message);
            queryClient.removeQueries();
            handleMdlSaveClose();
        } catch (err) {
            console.log(err);
            customAlert(err);
        }
        setLoadingScreen(false)
    }


    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {currProj ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2.5}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Set CFP Approval Limit  ({currProj?.actProjIdStrg}) </Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <LabelTxtFieldInfo defaultValue={currProj?.amtLimit} name="amtLimit" title="Amount (OMR)" type={"number"} width={"100%"} borderRadius={1} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 1 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SET</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default EditProjAmtLmit;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};


